import { createComponent } from '@lit/react'
import * as React from 'react'

import Component from '../../components/icons/design/design-tools-line/design-tools-line.js'

const tagName = 'dap-ds-icon-tools-line'

/**
 * `dap-ds-icon-tools-line`
 * @summary An icon
 * @element dap-ds-icon-tools-line
 * @title - DesignToolsLine
 * @group icon
 * @icontype design
 *
 * @attribute {number} size - (optional) The width and height in pixels
 * @attribute {boolean} selected - (optional) Sets the icon color via the `fill` attribute
 * @attribute {string} accessibilityTitle - (optional) When using the icon standalone, make it meaningful for accessibility
 * @attribute {boolean} focusable - (optional) If `true` the icon can receive focus
 *
 * @csspart base - The main icon container.
 */
const reactWrapper = createComponent({
  tagName,
  elementClass: Component,
  react: React,
  events: {},
  displayName: 'DesignToolsLine',
})

export default reactWrapper
